var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.1888 0.822998H3.92821C2.2161 0.822998 0.823242 2.21586 0.823242 3.92796V9.18864C0.823242 10.9007 2.2161 12.2935 3.92821 12.2935H9.18889C10.9009 12.2935 12.2938 10.9007 12.2938 9.18864V3.92796C12.2938 2.21586 10.9009 0.822998 9.1888 0.822998V0.822998ZM11.6213 9.18864C11.6213 10.5299 10.5301 11.6211 9.1888 11.6211H3.92821C2.58689 11.6211 1.49569 10.5299 1.49569 9.18864V3.92796C1.49569 2.58665 2.58689 1.49545 3.92821 1.49545H9.18889C10.5301 1.49545 11.6213 2.58665 11.6213 3.92796V9.18864Z",
    fill: "#101237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5585 3.42236C4.82907 3.42236 3.42212 4.82931 3.42212 6.55875C3.42212 8.28818 4.82907 9.69513 6.5585 9.69513C8.28794 9.69513 9.69489 8.28818 9.69489 6.55875C9.69489 4.82931 8.28794 3.42236 6.5585 3.42236ZM6.5585 9.02268C5.19995 9.02268 4.09457 7.91739 4.09457 6.55875C4.09457 5.20019 5.19995 4.09481 6.5585 4.09481C7.91714 4.09481 9.02243 5.20019 9.02243 6.55875C9.02243 7.91739 7.91714 9.02268 6.5585 9.02268Z",
    fill: "#101237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77003 2.30859C9.25895 2.30859 8.84326 2.72437 8.84326 3.23536C8.84326 3.74643 9.25895 4.16221 9.77003 4.16221C10.2811 4.16221 10.6969 3.74643 10.6969 3.23536C10.6969 2.72428 10.2811 2.30859 9.77003 2.30859ZM9.77003 3.48967C9.62983 3.48967 9.51571 3.37555 9.51571 3.23536C9.51571 3.09507 9.62983 2.98104 9.77003 2.98104C9.91031 2.98104 10.0244 3.09507 10.0244 3.23536C10.0244 3.37555 9.91031 3.48967 9.77003 3.48967Z",
    fill: "#101237"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4705,
    height: 11.4705,
    fill: "white",
    transform: "translate(0.823242 0.822998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.f1a48f9ed737eaeefcd7d69275e59582.svg";
export { ForwardRef as ReactComponent };